import AsyncStorage from '@react-native-async-storage/async-storage'
import React, { createContext, PropsWithChildren, useEffect, useMemo, useState } from 'react'

interface Props {
  historyDays: number
  setHistoryDays: React.Dispatch<React.SetStateAction<number>>
}

const SettingsContext = createContext<Props | undefined>(undefined)

export const SettingsProvider = ({ children }: PropsWithChildren) => {
  const [historyDays, setHistoryDays] = useState(7)

  useEffect(() => {
    AsyncStorage.getItem('historyDays')
      .then(x => {
        if (x !== null) {
          setHistoryDays(parseInt(x, 10))
        }
      })
      .catch(console.error)
  }, [])

  useEffect(() => {
    AsyncStorage.setItem('historyDays', historyDays.toString()).catch(console.error)
  }, [historyDays])

  const props = useMemo<Props>(
    () => ({
      historyDays,
      setHistoryDays,
    }),
    [historyDays]
  )

  return <SettingsContext.Provider value={props}>{children}</SettingsContext.Provider>
}

export default SettingsContext
